export default __webpack_public_path__ + "static/media/placeholder-image-03.50b36332.jpg";